import { loopiColors, loopiInk, loopiNeutral, loopiSemantic } from './colors';

export const loopiTheme = {
  token: {
    fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    colorPrimary: loopiColors.DEFAULT,
    colorLink: loopiColors[600],
    colorLinkHover: loopiColors[500],
    colorLinkActive: loopiColors[700],
    colorInfo: loopiSemantic.info,
    colorSuccess: loopiSemantic.success,
    colorWarning: loopiSemantic.warning,
    colorError: loopiSemantic.error,
    colorTextBase: loopiInk[900],
    colorText: loopiInk[800],
    colorTextSecondary: 'rgba(42, 21, 31, 0.68)',
    colorTextTertiary: 'rgba(42, 21, 31, 0.48)',
    colorTextDescription: 'rgba(42, 21, 31, 0.58)',
    colorTextHeading: loopiInk[900],
    colorTextLabel: loopiInk[700],
    colorTextPlaceholder: 'rgba(71, 37, 56, 0.38)',
    colorTextLightSolid: '#FFFFFF',
    colorBorder: loopiNeutral[200],
    colorBorderSecondary: loopiNeutral[100],
    colorSplit: loopiNeutral[200],
    colorBgBase: loopiNeutral[0],
    colorBgLayout: loopiNeutral[100],
    colorBgContainer: 'rgba(255, 255, 255, 0.88)',
    colorBgElevated: loopiNeutral[0],
    colorBgSpotlight: loopiInk[900],
    colorFillSecondary: loopiNeutral[100],
    colorFillTertiary: loopiNeutral[50],
    colorFillAlter: loopiNeutral[100],
    controlItemBgActive: loopiColors[50],
    controlItemBgActiveHover: loopiColors[100],
    controlItemBgHover: loopiNeutral[100],
    controlOutline: 'rgba(217, 64, 136, 0.16)',
    controlOutlineWidth: 3,
    lineWidth: 1,
    borderRadius: 14,
    borderRadiusXS: 8,
    borderRadiusSM: 10,
    borderRadiusLG: 22,
    borderRadiusOuter: 24,
    boxShadow: '0 20px 48px rgba(20, 9, 15, 0.12)',
    boxShadowSecondary: '0 14px 36px rgba(20, 9, 15, 0.10)',
    boxShadowTertiary: '0 10px 24px rgba(20, 9, 15, 0.08)',
  },
  components: {
    Layout: {
      bodyBg: 'transparent',
      headerBg: 'transparent',
      siderBg: 'transparent',
      triggerBg: loopiInk[950],
      triggerColor: '#FFFFFF',
    },
    Menu: {
      itemBg: 'transparent',
      subMenuItemBg: 'transparent',
      itemColor: 'rgba(255, 255, 255, 0.76)',
      itemHoverColor: '#FFFFFF',
      itemHoverBg: 'rgba(255, 255, 255, 0.08)',
      itemSelectedBg: loopiColors[500],
      itemSelectedColor: '#FFFFFF',
      itemActiveBg: 'rgba(255, 255, 255, 0.12)',
      itemBorderRadius: 16,
      itemMarginInline: 12,
      iconSize: 18,
      collapsedIconSize: 18,
    },
    Button: {
      borderRadius: 999,
      contentFontSize: 14,
      contentFontSizeLG: 14,
      controlHeight: 42,
      controlHeightLG: 48,
      paddingInline: 18,
      paddingInlineLG: 20,
      fontWeight: 600,
      defaultBg: 'rgba(255, 255, 255, 0.92)',
      defaultColor: loopiInk[800],
      defaultBorderColor: loopiNeutral[300],
      defaultHoverBg: '#FFFFFF',
      defaultHoverColor: loopiInk[900],
      defaultHoverBorderColor: loopiColors[300],
      defaultActiveBg: loopiNeutral[50],
      defaultActiveBorderColor: loopiColors[400],
      primaryShadow: '0 12px 28px rgba(217, 64, 136, 0.24)',
    },
    Card: {
      headerBg: 'transparent',
      bodyPadding: 24,
      bodyPaddingSM: 20,
    },
    Input: {
      activeBorderColor: loopiColors[400],
      hoverBorderColor: loopiColors[300],
      activeShadow: '0 0 0 4px rgba(217, 64, 136, 0.12)',
      colorBgContainer: '#FFFFFF',
    },
    Select: {
      activeBorderColor: loopiColors[400],
      hoverBorderColor: loopiColors[300],
      optionActiveBg: loopiNeutral[50],
      optionSelectedBg: loopiColors[50],
      optionSelectedColor: loopiInk[900],
      selectorBg: '#FFFFFF',
    },
    Table: {
      headerBg: loopiNeutral[50],
      headerColor: loopiInk[700],
      headerSplitColor: loopiNeutral[200],
      borderColor: loopiNeutral[200],
      rowHoverBg: 'rgba(253, 231, 242, 0.82)',
    },
    Modal: {
      headerBg: 'transparent',
      contentBg: '#FFFFFF',
      footerBg: 'transparent',
    },
    Drawer: {
      colorBgElevated: '#FFFFFF',
    },
    Tabs: {
      inkBarColor: loopiColors[500],
      itemSelectedColor: loopiColors[600],
      itemHoverColor: loopiColors[500],
      itemActiveColor: loopiColors[700],
    },
    Segmented: {
      trackBg: loopiNeutral[100],
      itemSelectedBg: '#FFFFFF',
      itemSelectedColor: loopiInk[900],
    },
    Tag: {
      defaultBg: loopiNeutral[50],
      defaultColor: loopiInk[700],
    },
  },
};

export default loopiTheme;
